import { Component } from '@angular/core';
import { Router } from '@angular/router';

interface Industry {
  icon: string;
  nameKey: string;
  descriptionKey: string;
}

@Component({
  selector: 'app-fee',
  templateUrl: './fee.component.html',
  styleUrls: ['./fee.component.scss']
})
export class FeeComponent {

  constructor(private router: Router) {}

  selectedIndex: number | null = null;
  groupName = '';
  imagePreviewUrl: string | null = null;
  imageError: string | null = null;

  readonly MAX_IMAGE_SIZE = 5 * 1024 * 1024;
  readonly ALLOWED_EXTENSIONS = ['jpg', 'jpeg', 'heic', 'png'];

  industries: Industry[] = [
    { icon: 'assets/fee-icons/education.svg', nameKey: 'fee.industry_names.education', descriptionKey: 'fee.industry_subtitles.education' },
    { icon: 'assets/fee-icons/health.svg', nameKey: 'fee.industry_names.health_wellness', descriptionKey: 'fee.industry_subtitles.health_wellness' },
    { icon: 'assets/fee-icons/accounting.svg', nameKey: 'fee.industry_names.accounting', descriptionKey: 'fee.industry_subtitles.accounting' },
    { icon: 'assets/fee-icons/telecomunnication.svg', nameKey: 'fee.industry_names.telecommunications', descriptionKey: 'fee.industry_subtitles.telecommunications' },
    { icon: 'assets/fee-icons/hospitality.svg', nameKey: 'fee.industry_names.hospitality', descriptionKey: 'fee.industry_subtitles.hospitality' },
    { icon: 'assets/fee-icons/other.svg', nameKey: 'fee.industry_names.other', descriptionKey: 'fee.industry_subtitles.other' },
  ];

  selectCard(index: number): void {
    this.selectedIndex = index;
  }

  onImageSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    this.imageError = null;
    this.imagePreviewUrl = null;

    if (!input.files || input.files.length === 0) return;

    const file = input.files[0];
    const ext = file.name.split('.').pop()?.toLowerCase() ?? '';

    if (!this.ALLOWED_EXTENSIONS.includes(ext)) {
      this.imageError = 'Invalid file type. Please upload a JPG, JPEG, HEIC, or PNG image.';
      input.value = '';
      return;
    }

    if (file.size > this.MAX_IMAGE_SIZE) {
      this.imageError = 'File is too large. Maximum size is 5MB.';
      input.value = '';
      return;
    }

    const reader = new FileReader();
    reader.onload = () => {
      this.imagePreviewUrl = reader.result as string;
    };
    reader.readAsDataURL(file);
  }

  cancel(): void {
    this.selectedIndex = null;
    this.groupName = '';
    this.imagePreviewUrl = null;
    this.imageError = null;
  }

  save(): void {
    if (this.groupName.trim()) {
      this.router.navigate(['/admin/page/fees', this.groupName.trim()]);
    }
  }
}
